// Builds the report from the loaded package (content, map, configuration) and keeps the model up to date.
import { initContent, EN } from './content.js';
import { st, readHash } from './state.js';
import { setStart, loadLive, buildWeather } from './weather.js';
import { buildFleet, simulate, TUR, FARM } from './fleet.js';
import { initLogistics } from './logistics.js';
import { buildGlossary } from './tooltip.js';
import { buildLayout, head, view3d } from './layout.js';
import { initMap } from './map.js';
import { fillTurbineSelect } from './panels/turbine.js';
import { tsel } from './layout.js';
import { resetPlans, issueList } from './panels/maintenance.js';
import { render, setAlt } from './render.js';
import { wireEvents } from './events.js';
import { init3d, focus3d } from './view3d.js';

var RAW = null, tried = false, WEATHER_API = '';

function valid(key, v) {
  if (key === 'view') return EN.views.some(function (x) { return x.id === v; });
  if (key === 'scenario') return EN.scenarios.some(function (x) { return x.id === v; });
  if (key === 'overlay') return EN.overlays.some(function (x) { return x.id === v; });
  if (key === 'theme') return v === 'dark' || v === 'light';
  if (key === 'farm') return !!FARM[v];
  if (key === 'tur') return !!TUR[v];
  if (key === 'h') return /^\d+$/.test(v) && +v < 72;
  return false;
}

function model() {
  var base = { hwrt: st.hwrt, curtailNeg: st.curtailNeg, derate: st.derate ? st.tur : null, holiday: st.scenario === 'holiday' };
  simulate(base);
  setAlt(simulate(Object.assign({}, base, { hwrt: !st.hwrt, dry: true })));
  resetPlans();
}

function weather() {
  if (st.scenario === 'live' && !tried) {
    tried = true;
    head.querySelector('.wf-a').textContent = 'Loading the DWD weather forecast for the ten wind farms…';
    return loadLive(WEATHER_API, 7000).then(function (raw) { RAW = raw; buildWeather('live', RAW); }, function () { RAW = {}; buildWeather('live', RAW); });
  }
  buildWeather(st.scenario, RAW);
  return Promise.resolve();
}

// kind: 'scenario' (new weather), 'model' (new options); pickTop: select the turbine most at risk
function act(kind, pickTop) {
  var go = function () {
    model();
    if (pickTop) { var top = issueList()[0]; if (top) { st.tur = top.t.id; st.farm = top.t.farm.id; } }
    render();
  };
  if (kind === 'scenario') weather().then(go); else go();
}

export function createApp(root, site) {
  initContent(site.content);
  setStart(Date.now());
  buildFleet();
  initLogistics();
  initMap(site.map);
  buildGlossary();
  WEATHER_API = site.weatherApi || '';
  buildLayout(root, site.brand);
  fillTurbineSelect(tsel);
  readHash(valid);
  if (TUR[st.tur]) st.farm = TUR[st.tur].farm.id;
  wireEvents(act);
  init3d(view3d, site.lazy && site.lazy.turbine3d, function (id) { var row = root.querySelector('.wf-cr[data-comp="' + id + '"]'); if (row) { row.classList.add('pick'); setTimeout(function () { row.classList.remove('pick'); }, 1200); } focus3d(id); });
  weather().then(function () { model(); render(); });
  return true;
}
